import { Type, Heading, List, ListOrdered, Quote, Image, LayoutGrid, Columns3, Building2, Sparkles, Minus, MousePointer2, CalendarDays, Tag, Link, Table, Info } from 'lucide-react';

const icons = {
  paragraph: Type, heading: Heading, bulletList: List, orderedList: ListOrdered,
  blockquote: Quote, image: Image, emailImage: Image, hero: Image,
  horizontalRule: Minus, contentButton: MousePointer2, emailButton: MousePointer2,
  container: LayoutGrid, column: Columns3, listingCard: Building2,
  eventCard: CalendarDays, offerCard: Tag, sourceCitation: Link, table: Table,
  callout: Info, emailCallout: Info,
};

export function contentEditorBlockIcon(type, category) {
  return icons[type] || (['structure','layout'].includes(category) ? LayoutGrid : category === 'data' ? Building2 : Sparkles);
}

export function contentEditorBlockSummary(node) {
  if (!node) return '';
  const attrs = node.attrs || {};
  if (['container','column','bulletList','orderedList'].includes(node.type.name)) return `${node.childCount} ${node.childCount === 1 ? 'block' : 'blocks'}`;
  const summary = node.textContent || attrs.heading || attrs.title || attrs.label || attrs.caption || attrs.alt || attrs.name || attrs.snapshot?.name || attrs.snapshot?.title || attrs.listing?.name;
  return typeof summary === 'string' ? summary.replace(/\s+/g,' ').slice(0,100) : '';
}
